import styled from 'styled-components'

export const MenuList = styled.div`
  display: flex;
  flex-direction: column;
`

export const MenuItem = styled.div`
  background: ${({ theme }) => theme.colors.neutralW20};
  color: ${({ theme }) => theme.colors.neutralW90};
  padding: 16px 20px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &:nth-child(1) {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  &:nth-last-child(1) {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  &:not(:nth-last-child(1)) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutralW30};
  }
`

export const Footer = styled.div`
  margin-top: 24px;
  color: ${({ theme }) => theme.colors.neutralW90};
  display: flex;
  justify-content: space-around;
  font-size: 0.875rem;
  padding: 0 40px;
`
